import "./SecondaryInfoSection.css";
import { useTranslation } from "react-i18next";
import SecondaryInfoCard from "./secondaryInfoCard/SecondaryInfoCard";

export default function SecondaryInfoSection() {
  const { t } = useTranslation("translation", { keyPrefix: "main" });

  return (
    <section className="main__secondary-info" id="main__secondary-info">
      <div className="main__secondary-info__cards-wrapper">
        <SecondaryInfoCard type="purpose" title="activeGPurpose.activeGPurposeTitle">
          <ul className="main__secondary-info__card__text">
            <li>{t("activeGPurpose.activeGPurposeInfo")}</li>
            <li>{t("activeGPurpose.activeGPurposeInfo1")}</li>
            <li>{t("activeGPurpose.activeGPurposeInfo2")}</li>
          </ul>
        </SecondaryInfoCard>

        <SecondaryInfoCard type="volunteering" title="activeGVolunteering.activeGVolunteeringTitle">
          <p className="main__secondary-info__card__text">
            {t("activeGVolunteering.activeGVolunteeringInfo")}
          </p>
        </SecondaryInfoCard>

        <SecondaryInfoCard type="principles" title="activeGPrinciples.activeGPrinciplesTitle">
          <p className="main__secondary-info__card__text">
            {t("activeGPrinciples.activeGPrinciplesInfo")}
          </p>
        </SecondaryInfoCard>
      </div>
    </section>
  );
}
